import { Button, Typography, Row, Col } from 'antd'
import './index.scss'
import { useNavigate } from 'react-router-dom'

const { Title, Paragraph } = Typography

export const HeroSection = () => {
    const navigate = useNavigate()
    return (
        <div className="hero-container">
            {/* Main Hero Section */}
            <Row gutter={[48, 48]}>
                <Col xs={24} lg={12} className="hero-content">
                    <Title level={1} className="hero-title">
                        Discover Your Life <span>Purpose</span> – Unlock Direction, Clarity and Fulfillment Today!
                    </Title>
                    <Paragraph className="hero-description">
                        Founded by experts in learning and personal development, Moodra, an AI-powered platform, provides affordable,
                        personalized pathways to help individuals discover their purpose by combining scientifically validated self-assessments
                        and community driven support.
                    </Paragraph>
                    <Button type="primary" size="large" className="waitlist-button" onClick={() => navigate('/survey/beginning')}>
                        Start Survey
                    </Button>
                </Col>
                <Col xs={24} lg={12} className="hero-image-container">
                    <img
                        src="/images/home-hero1.png"
                        alt="Mobile app interface showcase"
                        className="hero-image"
                    />
                </Col>
            </Row>

            {/* About Us Section */}
            {/* <Row gutter={[48, 48]} className="about-row">
                <Col xs={24} md={12} className="about-content">
                    <Title level={2} className="about-title">
                        About Us
                    </Title>
                    <Paragraph className="about-description">
                        At Mooodra, we believe everyone deserves to live a life of purpose and meaning. Our mission is to provide an accessible, research-backed platform that helps each person discover their unique direction in life.
                    </Paragraph>
                    <Paragraph className="about-description">
                        Through a personalized, science-backed survey, we help guide you toward your true calling with your values, passions, and strengths. With a uniquely gamified experience to make self-discovery rewarding and engaging.
                    </Paragraph>
                    <Paragraph className="about-description">
                        With each milestone you reach, you'll be recognized for your progress, empowering you to keep moving forward and stay motivated.
                    </Paragraph>
                </Col>
                <Col xs={24} md={12} className="about-image-container">
                    <img
                        src="/images/home-about-us.png"
                        alt="Illustration of hands reaching upward"
                        className="about-image"
                    />
                </Col>
            </Row> */}
        </div>
    )
}

